export var PrefixUri = function () {
    var paths = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        paths[_i] = arguments[_i];
    }
    return paths.filter(function (each) { return each !== null && each !== "" && each !== "/"; }).join("/");
};
